import {combineReducers, configureStore} from "@reduxjs/toolkit";
import LoadReducer from "./LoadReducer";

const rootReducer = combineReducers({
    flowviewer: LoadReducer
});

export const store = configureStore({
    reducer: rootReducer
});
